import React from 'react';

import {TableColumnType} from 'notebook/tables/constants/TableColumnConstants';
import TableAxisCell, {TableAxisCellProps} from 'notebook/tables/core-ui/TableAxisCell';
import UnitsTableAxisCell from 'notebook/tables/core-ui/UnitsTableAxisCell';
import {useAxisCellModel} from 'notebook/tables/store/hooks/useAxisCellModel';
import {isColumnHeaderModel} from 'notebook/tables/store/models/AxisCellModel';

/**
 * A column header cell, rendered with the unit-aware variant for the column types whose header
 * offers a unit picker. The variant is chosen from the header's own model, so a column header can
 * be rendered knowing only which column it labels.
 *
 * Rendered by `TableHeaderRow` for regular columns and by `TableSingleInput` for Single Inputs.
 */
export default function ColumnHeaderAxisCell(props: TableAxisCellProps): JSX.Element {
  const columnDefinitionType = useAxisCellModel((axisCellModel) =>
    isColumnHeaderModel(axisCellModel) ? axisCellModel.columnConstraint?.columnDefinition?.type : null
  );
  switch (columnDefinitionType) {
    case TableColumnType.QUANTITY:
    case TableColumnType.CONCENTRATION:
      return <UnitsTableAxisCell {...props} />;
    default:
      return <TableAxisCell {...props} />;
  }
}
